var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth == false)?_c('div',[_c('CardConfirmAuth')],1):_c('div',[_c('CardUserAuth')],1)}
var staticRenderFns = []

export { render, staticRenderFns }